/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { getProductEditions } from '@jira/platform__utils-get-meta/src/utils/get-meta-product-editions/index.tsx';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

export const getCustomAttributes = (): {
	exposureSource: string;
	'jira-software_edition': string;
	'jira-servicedesk_edition': string;
	'jira-workmanagement_edition': string;
} => ({
	...getProductEditions(),
	exposureSource: __SERVER__ ? 'server' : 'client',
});

type WindowStatsigValues = { _statsigValues?: Record<string, unknown> };

const valuesFromGlobal = (() => {
	// oxlint-disable-next-line typescript/consistent-type-assertions
	const globalVar = (typeof window !== 'undefined' ? window : globalThis) as WindowStatsigValues;
	return {
		locator: () => '_statsigValues' in globalVar,
		processor: () => globalVar._statsigValues,
	};
})();

const valuesFromMeta = (() => {
	// If parsing fails once, it will always fail. Avoid overhead of parsing again & again.
	let parsingFailed = false;

	const locator = () => {
		if (parsingFailed) {
			return null;
		}

		const statsigValues = getMeta('ajs-fe-statsig-values');

		try {
			const statsigValues2 = getMeta('ajs-fe-statsig-values-2');
			if (statsigValues && statsigValues2) {
				const statsigValuesObject = JSON.parse(statsigValues);
				const statsigValues2Object = JSON.parse(statsigValues2);

				Object.assign(statsigValuesObject.feature_gates, statsigValues2Object);
				return JSON.stringify(statsigValuesObject);
			}

			return statsigValues;
		} catch (e) {
			return statsigValues;
		}
	};

	return {
		locator,
		processor: () => {
			if (parsingFailed) {
				throw new Error("Can't parse 'ajs-fe-statsig-values' value");
			}

			const featureFlags = locator();
			if (featureFlags != null && featureFlags !== '') {
				globalThis.performance?.mark?.('statsig-parse:start');
				try {
					const result = JSON.parse(featureFlags);
					globalThis.performance?.mark?.('statsig-parse:end');
					return result;
				} catch {
					parsingFailed = true;
					throw new Error("Can't parse 'ajs-fe-statsig-values' value");
				}
			}
		},
	};
})();

export const _haveValuesArrived = (): boolean => {
	return Boolean(valuesFromGlobal.locator() || valuesFromMeta.locator());
};

export const getGateValues = (): Record<string, unknown> | undefined => {
	if (valuesFromGlobal.locator()) {
		return valuesFromGlobal.processor();
	}
	if (valuesFromMeta.locator()) {
		return valuesFromMeta.processor();
	}
	return undefined;
};
